import angular from 'angular';
import uiRouter from 'angular-ui-router';
import schedulerComponent from './scheduler.component';
import schedulerService from './scheduler.service';

let schedulerModule = angular.module('scheduler', [
  uiRouter
])

.component('scheduler', schedulerComponent)
.service('schedulerService', schedulerService)

.name;

export default schedulerModule;



// WEBPACK FOOTER //
// ./client/app/common/scheduler/scheduler.js